var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pdf-view',{key:_vm.componentKey,attrs:{"src":_vm.src},on:{"loaded":_vm.loaded}})}
var staticRenderFns = []

export { render, staticRenderFns }